import { render, staticRenderFns } from "./FakturPajakUserAccess.vue?vue&type=template&id=6da98cb3&scoped=true"
import script from "./FakturPajakUserAccess.vue?vue&type=script&lang=js"
export * from "./FakturPajakUserAccess.vue?vue&type=script&lang=js"
import style0 from "./FakturPajakUserAccess.vue?vue&type=style&index=0&id=6da98cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da98cb3",
  null
  
)

export default component.exports